export default {
	NAV_HEADER: 'Store Tasks',
	ORDER_CONFIRMATION_TEXT: 'Your order is now registered!',
	COUNT_CONFIRMATION_TEXT: 'Your count is now registered!',
	// NOTE: 'Data was removed from your phone storage too!',
	DONE: 'Done'
};